import { createStyles, makeStyles } from '@material-ui/core'

export default makeStyles((theme) =>
  createStyles({
    root: {
      backgroundColor: theme.palette.primary.main,
      color: 'white',
    },
    navHeading: {
      color: 'white',
      fontWeight: 'bold',
      textTransform: 'uppercase',
      [theme.breakpoints.only('xs')]: {
        display: 'block',
        textAlign: 'center',
        marginBottom: theme.spacing(2),
      },
    },
    navLink: {
      color: 'white',
    },
    socialIcon: {
      color: 'white',
      marginRight: theme.spacing(2),
    },
    socialIconsWrapper: {
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      [theme.breakpoints.only('xs')]: {
        justifyContent: 'center',
      },
    },
    downloadButton: {
      color: 'white',
      border: '1px solid',
      borderRadius: 0,
      width: 150,
      height: 50,
      flexShrink: 0,
    },
    downloadButtonsWrapper: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: theme.spacing(2),
      marginTop: theme.spacing(2),
      [theme.breakpoints.only('xs')]: {
        justifyContent: 'center',
        marginTop: 0,
      },
    },
    copyright: {
      marginTop: theme.spacing(2),
      [theme.breakpoints.only('xs')]: {
        textAlign: 'center',
      },
    },
  })
)
